var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1712756955787,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 5239,
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M578.74622 225.228 820.105334 466.587114 432.031177 854.661271 190.672063 613.302157 578.74622 225.228ZM664.984921 138.989298C688.799081 115.175139 727.043317 114.808993 751.254445 139.020121L906.313214 294.07889C930.144396 317.910072 930.324223 356.368225 906.344035 380.348412L863.224685 423.467763 621.865571 182.108649 664.984921 138.989298ZM184.228496 798.948869C182.994181 834.510978 210.676059 862.344234 246.384466 861.104838L432.031177 854.661271 190.672063 613.302157 184.228496 798.948869Z",
    fill: "#2c2c2c",
    "p-id": 5240
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.bebe134c2b3b223831b6db2a8ad10d8d.svg";
export { ForwardRef as ReactComponent };